import { Check } from 'lucide-react';

import { cn } from '@apps/web/lib/utils';

export function V3RowSelectionCheckbox({
    label,
    selected,
    disabled = false,
    onChange,
}: {
    readonly label: string;
    readonly selected: boolean;
    readonly disabled?: boolean;
    readonly onChange: () => void;
}) {
    return (
        <button
            type="button"
            role="checkbox"
            aria-label={label}
            aria-checked={selected}
            disabled={disabled}
            className={cn(
                'inline-flex size-5 shrink-0 items-center justify-center rounded-md border transition-colors',
                'focus-visible:ring-2 focus-visible:ring-[#5533EE] focus-visible:outline-none',
                selected
                    ? 'border-[#5533EE] bg-[#5533EE] text-white'
                    : 'border-[#AABBBB] bg-white text-transparent hover:border-[#5533EE]',
            )}
            onClick={onChange}
        >
            <Check className="size-3.5" aria-hidden="true" />
        </button>
    );
}
